import React from "react";
import { typography, textColors, borders, surfaces, interactive } from "../../../design-system/tokens";

function getPreviewTextFromValues(allValues) {
  if (!allValues || typeof allValues !== "object") return null;
  const candidateFields = [
    "text",
    "title",
    "label",
    "button_text",
    "subtitle",
    "content",
    "description",
    "name",
  ];
  for (const key of candidateFields) {
    const v = allValues[key];
    if (typeof v === "string" && v.trim().length > 0) {
      return v.trim();
    }
  }
  return null;
}

function getTextFromSelectedElement(selectedElement) {
  if (!selectedElement || typeof selectedElement !== "object") return null;
  const perType = {
    title: ["text", "title"],
    text: ["text", "content"],
    button: ["text", "label", "button_text"],
    hero: ["title", "subtitle", "text"],
    image: ["caption", "alt", "title"],
  };
  const keys = perType[selectedElement.type] || ["text", "title", "label", "name", "description"]; 
  for (const key of keys) {
    const v = selectedElement[key];
    if (typeof v === "string" && v.trim()) return v.trim();
  }
  return null;
}

function applyTransform(text, transform) {
  if (typeof text !== "string") return "";
  switch (transform) {
    case "uppercase":
      return text.toUpperCase();
    case "lowercase":
      return text.toLowerCase();
    case "capitalize":
      return text.replace(/\b\w/g, (m) => m.toUpperCase());
    case "none":
    default:
      return text;
  }
}

function TransformChip({ value, label, selected, onSelect, sample }) {
  return (
    <button
      type="button"
      onClick={() => onSelect(value)}
      className={`w-full text-left border rounded-lg px-3 py-2 mb-2 transition-all ${
        selected ? `${interactive.selectedBg} text-white ${interactive.selectedBorder} shadow-sm` : `${borders.default} ${surfaces.primary} ${surfaces.hover}`
      }`}
      aria-pressed={selected}
    >
      <div className={`font-medium ${typography.bodySmall} ${selected ? "text-white" : textColors.primary}`}>{label}</div>
      <div className={`mt-1 whitespace-nowrap overflow-hidden text-ellipsis ${typography.caption} ${selected ? "text-white/70" : textColors.tertiary}`} title={sample}>
        {sample}
      </div>
    </button>
  );
}

export default function TextTransformField({ label, help, value, onChange, choices, allValues, selectedElement }) {
  const fallback = "The quick brown fox jumps over the lazy dog";
  const textRaw = getTextFromSelectedElement(selectedElement) || getPreviewTextFromValues(allValues) || fallback;
  const previewText = textRaw.length > 160 ? textRaw.slice(0, 157) + "…" : textRaw;

  const normalized = (choices || []).map((c) => ({ value: c.value, label: c.label }));

  return (
    <div className="field-wrapper">
      <label className={`block mb-2 ${typography.label} ${textColors.secondary}`}>{label}</label>
      <div
        className="grid gap-2"
        style={{ gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))" }}
      >
        {normalized.map((c) => (
          <TransformChip
            key={c.value}
            value={c.value}
            label={c.label}
            selected={value === c.value}
            onSelect={(val) => onChange(val)}
            sample={applyTransform(previewText, c.value)}
          />
        ))}
      </div>
      {help && <div className={`mt-1 ${typography.caption} ${textColors.tertiary}`}>{help}</div>}
    </div>
  );
}


